import jQuery from 'jquery';
import v5_Model from '@/models/v5/model';
import Api from '@/lib/api/api';

var model = v5_Model.extend({
    /**
     * Noop the fetch function for roles 
     * because GET doesn't work on the API
     */
    fetch: function() {
        return new (jQuery.Deferred()).resolve();
    },
    urlRoot: function() {
        return Api.urls.roles();
    },
    initialize: function() {
        this.type = model.type;
    }
});
model.type = 'account_role';
export default model;

